<template>
  <v-container>
    <v-dialog
      v-model="modal"
      width="400px"
    > 
      <v-card class="investment-dialog">
        <v-card-title>Confirmar inversión demo</v-card-title>
        <v-card-text v-if="!receipt">
          <v-row class="popup-row">
            <v-col cols="8">
              Dinero en billetera virtual:
            </v-col>
            <v-col cols="4">
              {{walletInfo.balance}} {{walletInfo.currency}}
            </v-col>
          </v-row>
          <v-row class="popup-row">
            <v-col cols="8">
              Cantidad de créditos disponible:
            </v-col>
            <v-col cols="4">
              {{investmentData.creditsAvailable}}
            </v-col>
          </v-row>
          <v-row class="popup-row">
            <v-col cols="8">
              Precio por crédito:
            </v-col>
            <v-col cols="4">
              {{creditPrice}}
            </v-col>
          </v-row>
          <v-row class="popup-row">
            <v-col cols="7">
              Tipo de compra:
            </v-col>
            <v-col cols="5">
              <v-select dense :items="buymentTypes" item-value="id" item-text="type" v-model="buymentType" /> 
            </v-col>
          </v-row>
          <v-row class="popup-row">
            <v-col cols="7">
              Monto de compra:
            </v-col>
            <v-col cols="5">
              <v-text-field @input="buildBuymentSummary" v-if="buymentType===0" dense :rules="moneyRules" type="number" min="0" v-model.number="moneyForBuyment" required />
              <v-text-field @input="buildBuymentSummary" v-if="buymentType===1" dense :rules="creditRules" type="number" min="0" v-model.number="creditsToBuy" required />
            </v-col>
          </v-row>
          <v-row class="popup-row">
            <v-col cols="12">
              {{buymentSummary}}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else class="receipt">
          <v-icon class="receipt__icon">mdi-check-circle-outline</v-icon>
          <h3>Inversión confirmada</h3>
          <p>La operación quedó registrada y ya forma parte de tu cartera demo.</p>
          <div><span>Créditos</span><b>{{ receipt.credits }}</b></div>
          <div><span>Capital invertido</span><b>{{ money(receipt.subtotal) }}</b></div>
          <div><span>Comisión</span><b>{{ money(receipt.commission) }}</b></div>
          <div><span>Total debitado</span><b>{{ money(receipt.total) }}</b></div>
          <small>Operación {{ receipt.transactionId }}</small>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" align="center">
            <v-tooltip bottom v-if="!receipt && disableInvestment">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn disabled> Completar Inversión</v-btn>
                </div>
              </template>
              <span>El valor ingresado es incorrecto</span>
            </v-tooltip>
            <v-btn v-else-if="!receipt" color="secondary" :loading="submitting" @click="completeInvestment">Confirmar inversión demo</v-btn>
            <v-btn v-if="receipt" color="secondary" @click="finishInvestment">Ver mi cartera</v-btn>
            <v-btn v-else text :disabled="submitting" @click="modal=false">Cancelar</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  props:{
    dialog:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      walletInfo:{
        balance: 0,
        currency: 'ARS'
      },
      investmentAccount:{},
      investCommission:0,
      creditsToBuy:0,
      moneyForBuyment:0,
      creditPrice:0,
      investment:0,
      buymentType:0,
      buymentTypes:[
        {
          id:0,
          type:'Monto total'
        },
        {
          id:1,
          type:'Créditos'
        }
      ],
      buymentSummary: '',
      receipt:null,
      modal:false,
      submitting:false,
      creditRules:[
        v => Number(v)>=1 || 'La inversión mínima es de un crédito.',
        v => Number(v)<=this.investmentData.creditsAvailable || 'Valor mayor al de créditos disponibles.'
      ],
      moneyRules:[
        v => Number(v)>=this.costWithCommission(this.creditPrice) || 'El monto mínimo equivale a un crédito.',
        v => Number(v) <=this.walletInfo.balance || 'Valor mayor al disponible en billetera virtual.',
        v => this.creditsFromMoney(Number(v))<=this.investmentData.creditsAvailable || 'Valor mayor al de créditos disponibles.'
      ]
    }
  },
  computed:{
    ...mapGetters([
      'oidcUser'
    ]),
    investmentData(){
      return this.$store.getters.getInvestmentData
    },
    creditsCost(){
      return this.creditsToBuy * this.creditPrice
    },
    disableInvestment(){
      const credits = this.buymentType === 0 ? this.creditsFromMoney(this.moneyForBuyment) : Number(this.creditsToBuy)
      const total = this.buymentType === 0 ? Number(this.moneyForBuyment) : this.costWithCommission(this.creditsCost)
      return this.submitting || !Number.isFinite(credits) || credits < 1 || credits > this.investmentData.creditsAvailable || total > this.walletInfo.balance
    },
    
  },
  async beforeMount(){
    this.modal = this.dialog
    this.creditPrice = this.investmentData.creditPrice
    await this.getProjectInfo()
    this.$cf_api.getCommissions().then(response=>{ 
      this.investment = parseFloat(response.data.investment)
    }).catch(e=>{
      console.log('Error retrieving commission fees: ',e)
    })
  },
  watch:{
    modal(newVal){
      if(!newVal){
        this.$store.dispatch('clearInvestment')
      }
    }
  },
  methods:{
    getProjectInfo(){
      this.$cf_api.getUserFinancialAccounts(this.oidcUser.name).then(response=>{
        this.walletInfo.balance = response.data.accounts[0].balance
        this.walletInfo.currency = response.data.accounts[0].currencyIso
        const accounts = response.data.investmentAccounts || response.data.investmentAccount || []
        this.investmentAccount = accounts.find(el => el.projectId === this.investmentData.projectId) || {}
      }).catch(e=>{
        console.log('Error retreiving user account info: ',e)
      })
    },
    completeInvestment(){
      if (this.disableInvestment) return
      this.submitting = true
      let credits = this.buymentType === 1 ? Number(this.creditsToBuy) : this.creditsFromMoney(this.moneyForBuyment)
      this.$cf_api.investProject({ projectId: this.investmentData.projectId, creditPrice: this.creditPrice, creditsAmount: credits, userName: this.oidcUser.name})
      .then((response)=>{
        this.$store.dispatch('setSnack', 'Inversión demo realizada correctamente.')
        const rawReceipt = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
        // cf-financial (Newtonsoft) preserves the DTO's PascalCase properties while
        // the SPA normally consumes camelCase JSON. Normalize the receipt at the
        // boundary so the confirmation stays correct with either serializer.
        this.receipt = {
          transactionId: rawReceipt.transactionId || rawReceipt.TransactionId,
          credits: rawReceipt.credits !== undefined ? rawReceipt.credits : rawReceipt.Credits,
          subtotal: rawReceipt.subtotal !== undefined ? rawReceipt.subtotal : rawReceipt.Subtotal,
          commission: rawReceipt.commission !== undefined ? rawReceipt.commission : rawReceipt.Commission,
          total: rawReceipt.total !== undefined ? rawReceipt.total : rawReceipt.Total
        }
      }).catch(e=>{
        console.log('Error investing in projects',e)
        this.$store.dispatch('setSnack', 'No se pudo completar la inversión. Revisá tu saldo e intentá nuevamente.')
        this.$emit('actionResult', false)
      }).finally(() => { this.submitting = false })
    },
    finishInvestment () {
      this.$emit('actionResult', true)
      this.modal = false
      this.$router.push('/self')
    },
    money (value) {
      return new Intl.NumberFormat('es-AR', { style: 'currency', currency: this.walletInfo.currency || 'ARS', maximumFractionDigits: 0 }).format(Number(value) || 0)
    },
    creditsFromMoney(value){
      return Number(value) / this.costWithCommission(this.creditPrice)
    },
    costWithCommission(value){
      return Math.round(Number(value) * (1 + Number(this.investment)) * 100) / 100
    },
    buildBuymentSummary(){
      if(this.buymentType ===0){
        this.buymentSummary = `Recibís ${this.creditsFromMoney(this.moneyForBuyment).toFixed(2)} créditos (${this.creditPrice} por crédito + comisión ${100*this.investment}%).`
      } else if(this.buymentType ===1) {
        this.buymentSummary = `Costo total ${this.costWithCommission(this.creditsCost)} ${this.walletInfo.currency} (${this.creditPrice} por crédito + comisión ${100*this.investment}%).`
      }
    }
  }
}
</script>
<style scoped>
.popup-row{
  justify-content: center;
  align-content: center;
  height:50px !important;
}
.investment-dialog{padding:8px;min-height:430px}.investment-dialog .v-card__title{font-family:Georgia,serif;font-size:25px;color:#173347}.investment-dialog .v-btn{text-transform:none;letter-spacing:0;font-weight:700}
.receipt{text-align:center;color:#173347}.receipt__icon{font-size:52px;color:#4f8b70}.receipt h3{font-family:Georgia,serif;font-size:27px;margin:12px 0}.receipt p{color:#64747e;font-size:13px}.receipt div{display:flex;justify-content:space-between;border-top:1px solid #ece8e1;padding:10px 0}.receipt small{display:block;color:#89949a;word-break:break-all;margin-top:16px}
</style>
